/**
 * Success / error toasts the way every console shows them: a Snackbar with
 * a filled Alert. `notify('Saved')`, `notify(message, 'error')`. Render
 * `feedback` once anywhere in the component's tree.
 */
import { useCallback, useState } from 'react';
import { Alert, AlertColor, Snackbar } from '@mui/material';

export function useFeedback() {
  const [state, setState] = useState<{ message: string; severity: AlertColor } | null>(null);

  const notify = useCallback((message: string, severity: AlertColor = 'success') => {
    setState({ message, severity });
  }, []);

  const close = () => setState(null);

  const feedback = (
    <Snackbar
      open={!!state}
      autoHideDuration={severityDuration(state?.severity)}
      onClose={close}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      {state ? (
        <Alert severity={state.severity} variant="filled" onClose={close} sx={{ width: '100%' }}>
          {state.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );

  return { notify, feedback };
}

/** Errors stay a little longer; a success just needs to be seen. */
const severityDuration = (severity?: AlertColor) => (severity === 'error' ? 7000 : 4000);
